import React from "react";
import { Autocomplete } from "@material-ui/lab";
import {
  TextField,
  Divider,
  IconButton,
  ListItemIcon,
  Tooltip,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { styles } from "./styles";
import logoutIcon from "../../img/logout1.png";
import { UserAction } from "../../actions/user";
import LogoModal from "./LoGOModal";
import { useState } from "react";
import CahngePasswordModal from "./CahngePasswordModal";
import { AddressAction } from "../../actions/Address";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Typography } from "antd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

const RightSideHeader = ({ setFileView, setIMG, img, fileView }) => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [openModalpassword, setOpenModalPassword] = useState(false);
  const [currentPassword, setcurrentPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  // const [values, setValues] = React.useState({
  //   currentPassword: "",
  //   newPassword: "",
  //   confirmPassword: "",
  //   showPassword: false,
  // });
  const handleLogout = async () => {
    window.open(`/`, "_self");
    window.localStorage.clear();
  };

  const choseFile = () => {
    document.getElementById("showFile").click();
  };
  const uploadLogo = () => {
    console.log(img, "jhuhuyhu");
    let data = new FormData();
    data.append("userId", JSON.parse(localStorage.getItem("data")).id);
    data.append(
      "companyId",
      JSON.parse(localStorage.getItem("data")).companyId
    );
    data.append("file", img);
    // let data={
    //   userId:JSON.parse(localStorage.getItem("data")).coreUserId,
    //   companyId:JSON.parse(localStorage.getItem("data")).companyId ,
    //   file:img
    // }
    if (img){
      UserAction.AddLogo(data).then((response) => {
        if (response !== null) {
          alert("Add Logo Success");
          localStorage.setItem("dealerLogoUrl", JSON.stringify(response));
          setOpenModal(false);
          window.location.reload();
        } else {
        }
      });
    }else{
      alert('Please select image!!')
    }
  };
  const handleOpen = () => {
    setOpenModal(true);
  };

  const onFileChange = (event) => {
    // if (event.target.files[0].size > 1000000 ) {
    //        alert("Please upload a file smaller than 1 MB");
    //         document.getElementById("showFile3").value = "";
    //         setFileView("")
    //          return false;
    //        }
    setIMG(event.target.files[0]);
    var reader = new FileReader();
    reader.onload = function (e) {
      console.log(e.target.result);

      setFileView(e.target.result);
      document.getElementById("showFile3").value = "";
    };
    reader.readAsDataURL(event.target.files[0]); // convert to base64 string

    // ArrCopy=Arr[0];
    // console.log(Arr)
  };
  const changepassword = () => {
    setOpenModalPassword(true);
    setOpen(false);
    // setAnchorEl(null);
  };
  const changepasswordhandler = () => {
    // const myArray = newPassword.trim().split(" ");
    // if (newPassword == undefined) {
    //   alert("Plz Enter Your  New Password");
    //   return false;
    // } else if (myArray.length > 1) {
    //   alert("No space allowed!!!");
    //   return false;
    // } else if (confirmPassword == undefined) {
    //   alert("Plz Enter Your  Confirm Password");
    //   return false;
    // } else if (confirmPassword !== newPassword) {
    //   alert("New and confirm Password must be same ");
    //   return false;
    // }
    // const data = {
    //   email: JSON.parse(localStorage.getItem("data")).email,
    //   password: confirmPassword,
    // };
    // AddressAction.changeAPssword(data).then((response) => {
    //   if (response !== null) {
    //     alert("Your Password Changed successfully");
    //   }
    // });
    // setcurrentPassword("");
    // setconfirmPassword("");
    // setnewPassword("");

    const myArray = newPassword.trim().split(" ");
    if (currentPassword == "") {
      alert("Plz Enter Your  Old Password");
      return false;
    } else if (newPassword == "") {
      alert("Plz Enter Your  New Password");
      return false;
    } else if (myArray.length > 1) {
      alert("No space allowed!!!");
      return false;
    } else if (confirmPassword == "") {
      alert("Plz Enter Your  Confirm Password");
      return false;
    } else if (confirmPassword !== newPassword) {
      alert("New and confirm Password must be same ");
      return false;
    }

    const data = {
      email: JSON.parse(localStorage.getItem("data")).email,
      oldPassword:currentPassword,
      password: confirmPassword,
    };
    AddressAction.changeAPssword(data).then((response) => {
      if (response.responseCode == 200) {
        alert("Your Password Changed successfully");
      }
    else if (response.responseCode == 403) {
        alert("Old password doesnt match! ");
      }
      else{
        console.log("error")
      }
    });
    setcurrentPassword("");
    setconfirmPassword("");
    setnewPassword("");
    setOpenModalPassword(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const onmouseMove = () => {
    setOpen(true);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const mouseleavehandler = () => {
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  return (
    <div style={styles.rightSubCont} id="nav_header">
      {/* <Autocomplete id='header'
        getOptionLabel={(option) => option.name}
        className='headerSelect'
        options={[]}
        style={{ width: 200 }}
        filterSelectedOptions
        getOptionSelected={(option, value) => option.name === value.name}
        disableClearable
        renderInput={(params) =>
          <TextField
            {...params}
            variant='outlined'
            margin='dense'
          />
        }
      /> */}
      {/* <Divider style={styles.divider} orientation='vertical' flexItem /> */}
      {JSON.parse(localStorage.getItem("data")).userType == "DEALER" && (
        <span style={styles.span} className="mr-5">
          {/* <AccountCircle style={styles.userIcon} /> */}
          {/* {img == null ? (
            <b onClick={choseFile}>ChoseFile Logo</b>
          ) : (
            <b onClick={uploadLogo}>Upload Logo</b>
          )} */}
          <b onClick={handleOpen}>Upload Logo</b>
          <LogoModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            onFileChange={onFileChange}
            fileView={fileView}
            uploadLogo={uploadLogo}
          />

          {/* <b onClick={handleOpen}>ChoseFile Logo</b> */}
          {/* <input
            id="showFile"
            style={{
              border: "none",
              outline: "none",
              display: "none",
            }}
            type="file"
            accept="Image/png, Image/jpeg"
            onChange={onFileChange}
            variant="outlined"
          /> */}
        </span>
      )}
      {/* <span style={styles.span} className="mr-3">
        <AccountCircle style={styles.userIcon} />
        <b>
          {localStorage.getItem("email") == "route@watsoo.com"
            ? "Route"
            : JSON.parse(localStorage.getItem("data")).name}
        </b>
      </span>
      <span style={styles.span} className="mr-3">
        <LockOpenIcon style={styles.PasswordIcon} onClick={changepassword} />
        <span>Change Password</span>
      </span>

      <span
        className="cousor_pointer "
        style={styles.span}
        onClick={handleLogout}
      >
        <img className="ml-1" src={logoutIcon} alt="route" />
        <b className="ml-1">Logout</b>
      </span> */}

      <div className={classes.root}>
        <div>
          <Button
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            onMouseEnter={onmouseMove}
          >
            <span style={styles.span} className="mr-3">
              {/* <Tooltip title="Click" aria-label="add"> */}

              <AccountCircle
                style={styles.userIcon}
                className="menuaIocnBtn"

                //onMouseLeave={mouseleavehandler}
              />
              {/* </Tooltip> */}
              <b>
                {localStorage.getItem("email") == "route@watsoo.com"
                  ? "Route"
                  : JSON.parse(localStorage.getItem("data")).name}
              </b>
            </span>
          </Button>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper style={{ marginTop: "5px" }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={changepassword}>
                        <ListItemIcon>
                          <LockOpenIcon style={{ margin: "0 5px" }} />
                          <b>Change Password</b>
                        </ListItemIcon>
                      </MenuItem>
                      <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                          <ExitToAppIcon style={{ margin: "0 5px" }} />
                          <b>Logout</b>
                        </ListItemIcon>
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
      <CahngePasswordModal
        openModal={openModalpassword}
        setOpenModal={setOpenModalPassword}
        currentPassword={currentPassword}
        newPassword={newPassword}
        confirmPassword={confirmPassword}
        setcurrentPassword={setcurrentPassword}
        setnewPassword={setnewPassword}
        setconfirmPassword={setconfirmPassword}
        changepasswordhandler={changepasswordhandler}
      />
    </div>
  );
};

export default RightSideHeader;
